module.exports = __webpack_public_path__ + "static/scale-model-of-san-jose-museum-of-art-in-san-jose-california-9b43fa3a3514add40187bd8a398a24e0.png";